const NoDataText = {
  NotApplicable: 'NotApplicable',
  Dash: 'Dash',
} as const;

type NoDataText = (typeof NoDataText)[keyof typeof NoDataText];

export default NoDataText;
